<template>
    <div id="fiche-bu-priority-form-block">
        <div class="priority-block" v-for="(priority, i) in priorities" :key="priority.id + i">
            <div class="col-12 background-default-light evaluation-title-container">
                <as-title :title="priority['title' + locale]" :size="5" class="color-white p-0"></as-title>
                <span v-if="!edit"
                    :class="'p-1 ml-auto evaluation-picto color-white ' + this.getEvaluationsCssClass(priority.status)"
                    v-tooltip.left="getEvaluationsTooltip(priority.status)">
                    <i v-if="pdfBeingGenerated !== true" :class="'pi ' + this.getEvaluationsIcon(priority.status)"></i>
                    <img v-else class="p-1" :src="this.getEvaluationsImg(priority.status)"></img>
                </span>
            </div>
            <div class="col-12 background-default-lighter">
                <p> {{ priority['content' + locale] }}</p>
                <div v-if="edit" class="w-100">
                    <Dropdown class="col-12 p-0 mb-2" v-model="priority.status" :options="priorityStatusOptions"
                        optionLabel="label" optionValue="value" />
                    <div class="relative w-100" v-if="isAdmin">
                        <div id="translate-button" class="mt-3 mb-3" style="position: absolute; z-index: 1; right: 0;">
                            <TranslateButton :stringsToTranslate="getStringsToTranslate(i)"
                                @onTranslationSuccess="(translatedData, targetLangCode) => handleTranslationSuccess(i, translatedData, targetLangCode)" />
                        </div>
                        <TabView>
                            <TabPanel>
                                <template #header>
                                    <div class="flex align-items-center gap-2">
                                        <Avatar :image="getFlag('fr')" shape="square" />
                                        <span class="font-bold white-space-nowrap">FR</span>
                                    </div>
                                </template>
                                <div class="mt-3">
                                    <TinyMceEditor v-model="priority.commentFr" @update:modelValue="$forceUpdate()" />
                                </div>
                            </TabPanel>
                            <TabPanel>
                                <template #header>
                                    <div class="flex align-items-center gap-2">
                                        <div class="flex align-items-center gap-2">
                                            <Avatar :image="getFlag('en')" shape="square" />
                                            <span class="font-bold white-space-nowrap">EN</span>
                                        </div>
                                    </div>
                                </template>
                                <div class="mt-3">
                                    <div class="p-float-label">
                                        <TinyMceEditor v-model="priority.commentEn"
                                            @update:modelValue="$forceUpdate()" />
                                    </div>
                                </div>
                            </TabPanel>
                        </TabView>
                    </div>
                </div>
            </div>
            <div class="col-12 priority-block__comment" v-if="priority['comment' + locale] && !edit">
                <b>{{ $t('ficheBu.priority_list.comment_label') }} : </b>
                <div class="tinymce-content" v-html="priority['comment' + locale]"> </div>
            </div>
        </div>
    </div>
</template>

<script>
import Chip from 'primevue/chip';
import AsTitle from '../Elements/AsTitle.vue';

import TinyMceEditor from "@/components/Editor/TinyMceEditor.vue";
import Dropdown from 'primevue/dropdown';
import Avatar from "primevue/avatar";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import TranslateButton from "../Elements/TranslateButton.vue";

import roleMixins from "@/mixins/roleMixins";

export default {
    name: "FicheBuPriorityFormBlock",
    components: {
        AsTitle,
        Avatar,
        Dropdown,
        TabView,
        TabPanel,
        TinyMceEditor,
        TranslateButton,
        Chip
    },
    props: {
        edit: Boolean,
        pdfBeingGenerated: Boolean,
        priorities: {
            type: Array,
        }
    },
    computed: {
        locale() {
            const locale = this.$i18n.locale
            const firstLetter = locale.charAt(0).toUpperCase()
            const rest = locale.slice(1).toLowerCase()
            return firstLetter + rest;
        },
    },
    mixins: [roleMixins],
    methods: {
        getEvaluationsCssClass(value) {
            switch (value) {
                case 2: return 'background-evaluation-in-progress'
                case 3: return 'background-evaluation-ok'
                default: return 'background-evaluation-not-started'
            }
        },
        getEvaluationsIcon(value) {
            switch (value) {
                case 2: return 'pi-hourglass'
                case 3: return 'pi-check-square'
                default: return 'pi-calendar-times'
            }
        },
        getEvaluationsImg(value) {
            switch (value) {
                case 2: return this.hourglass
                case 3: return this.checkSquare
                default: return this.calendarTimes
            }
        },
        getEvaluationsTooltip(value) {
            switch (value) {
                case 2: return this.$t(`evaluations.IN_PROGRESS`)
                case 3: return this.$t(`evaluations.OK`)
                default: return this.$t(`evaluations.NOT_STARTED`)
            }
        },
        getFlag(iso) {
            return new URL(`../../assets/images/flags/${iso}.svg`, import.meta.url).href;
        },
        getStringsToTranslate(index) {
            const priorityToTranslate = this.priorities[index];
            const locale = this.$i18n.locale;
            return locale === 'fr' ? [priorityToTranslate.commentFr] : [priorityToTranslate.commentEn];
        },
        handleTranslationSuccess(index, translatedData, targetLangCode) {
            if (Array.isArray(translatedData) && translatedData.length === 1) {
                switch (targetLangCode) {
                    case 'en':
                        this.priorities[index].commentEn = translatedData[0];
                        break;
                    case 'fr':
                        this.priorities[index].commentFr = translatedData[0];
                        break;
                }
            }
        },
    },
    data() {
        return {
            priorityStatusOptions: [
                { label: this.$t(`evaluations.NOT_STARTED`), value: 1 },
                { label: this.$t(`evaluations.IN_PROGRESS`), value: 2 },
                { label: this.$t(`evaluations.OK`), value: 3 },
            ],
            hourglass: new URL("../../assets/images/fiche-bu/hourglass.png", import.meta.url).href,
            checkSquare: new URL("../../assets/images/fiche-bu/check-square.png", import.meta.url).href,
            calendarTimes: new URL("../../assets/images/fiche-bu/calendar-times.png", import.meta.url).href,
        };
    },
};
</script>

<style lang="scss">
@import "../../assets/styles/colors.scss";


#fiche-bu-priority-form-block {
    display: grid;
    grid-template-columns: repeat(2, minmax(350px, 1fr));
    gap: 20px;
    align-items: start;

    .priority-block {

        &__comment {
            background-color: #f7faff;
        }
    }

}

@media (max-width: 1099px) {
    #fiche-bu-priority-form-block {
        grid-template-columns: 1fr !important;
    }
}
</style>
